import React from "react";
import { isEqual } from "lodash";
import {
  ConsultantCardContentBase,
  ConsultantCardContentProps
} from "./ConsultantCardContentBase";

export class ConsultantCardContent extends React.Component<ConsultantCardContentProps> {
  shouldComponentUpdate(nextProps: ConsultantCardContentProps) {
    return (
      this.props.selected !== nextProps.selected ||
      !isEqual(this.props.item, nextProps.item)
    );
  }

  render() {
    return <ConsultantCardContentBase {...this.props} />;
  }
}
